<template>
    <div class="stretch">
        <ErrorField class="column" :condition="errors.value" field="This" type="required">
            <Dropdown
                :uniqueId="`segmentConditionBooleanField${id}`"
                class="value-field"
                :selectedId="valueAsNumber"
                :options="booleanOptions"
                defaultText="Select State"
                :searchEnabled="false"
                @dropdownSelectedItemChanged="valueChanged"
                height="34"
            />
        </ErrorField>
        <div>
            <slot name="afterInput"></slot>
        </div>
    </div>
</template>

<script>
import Dropdown from 'components/dropdowns/Dropdown.vue';
import ErrorField from 'components/errorField/ErrorField.vue';

export default {
    name: 'BooleanField',
    components: { ErrorField, Dropdown },
    props: {
        value: Boolean,
        errors: Object,
        id: Number
    },
    data() {
        return {
            booleanOptions: [
                { id: 1, displayText: 'True' },
                { id: 0, displayText: 'False' }
            ]
        };
    },
    computed: {
        valueAsNumber() {
            if (this.value === true) return 1;
            if (this.value === false) return 0;
            return this.value;
        }
    },
    methods: {
        valueChanged($event) {
            this.$emit('update:value', !!$event.id);
        }
    }
};
</script>
